import React from 'react';
import {
    Show,
    TabbedShowLayout,
    Tab,
    Datagrid,
    ArrayField,
    TextField,
    DateField,
    SelectField,
    BooleanField
} from 'react-admin';
import streetTypes from "../helper/StreetTypes";
import PhoneArrayField from "../component/PhoneArrayField";

const LegalEntityShow = props => {
    return (
        <Show {...props} title="Моя організація">
            <TabbedShowLayout>
                <Tab label="Загальна інформація">
                    <TextField label="ЕДРПОУ" source="edrpou"/>
                    <SelectField label="Тип" source="type" choices={[
                        {id: 'PHARMACY', name: 'Аптека'},
                        {id: 'MIS', name: 'Medical Information system'},
                        {id: 'EMERGENCY', name: 'Заклад з надання екстренної медичної допомоги'},
                        {id: 'MSP', name: 'заклад з надання медичних послуг'},
                        {id: 'MSP_PHARMACY', name: 'Заклад з надання медичних послуг та аптека'},
                        {id: 'PRIMARY_CARE', name: 'Заклад з надання первинної медичної допомоги'},
                        {id: 'OUTPATIENT', name: 'Вторинна, третинна, паліативна медична допомога та реабілітація'}
                    ]}/>
                    <TextField label="E-mail" source="email"/>
                    <TextField label="Web-сайт" source="website"/>
                    <TextField label="Код отримувача бюджетних коштів" source="receiverFundsCode"/>
                    <TextField label="ПІБ власника" source="beneficiary"/>
                </Tab>

                <Tab label="Адреса">
                    <SelectField label="Тип адресу" source="residenceAddress.type" choices={[
                        {id: 'RESIDENCE', name: 'адреса проживання/розташування/перебування'},
                        {id: 'REGISTRATION', name: 'адреса реєстрації'},
                        {id: 'RECEPTION', name: 'адреса приймальної'}
                    ]}/>
                    <SelectField label="Країна" source="residenceAddress.country" choices={[
                        {id: 'UA', name: 'УКРАЇНА'}
                    ]}/>
                    <TextField label="Область" source="residenceAddress.area"/>
                    <TextField label="Район" source="residenceAddress.region"/>
                    <TextField label="Населений пункт" source="residenceAddress.settlement"/>
                    <SelectField label="Тип населеного пункту" source="residenceAddress.settlementType" choices={[
                        {id: 'CITY', name: 'місто'},
                        {id: 'SETTLEMENT', name: 'селище'},
                        {id: 'TOWNSHIP', name: 'селище міського типу'},
                        {id: 'VILLAGE', name: 'село'}
                    ]}/>
                    <TextField label="Вулиця" source="residenceAddress.street"/>
                    <SelectField label="Тип вулиці" source="residenceAddress.streetType" choices={streetTypes}/>
                    <TextField label="Будинок та номер корпусу" source="residenceAddress.building"/>
                    <TextField label="Офіс" source="residenceAddress.apartment"/>
                    <TextField label="Поштовий індекс" source="residenceAddress.zip"/>
                </Tab>

                <Tab label="Телефони">
                    <PhoneArrayField label="Номер контактного телефону" source="phones" />
                </Tab>

                <Tab label="Ліцензія">
                    <TextField label="ID ліцензії" source="license.id"/>
                    <SelectField label="Категорія" source="license.type" choices={[
                        {id: 'PHARMACY', name: 'Аптека'},
                        {id: 'MSP', name: 'заклад з надання медичних послуг'}
                    ]}/>
                    <TextField label="Ким видана" source="license.issuedBy"/>
                    <DateField label="Дата видачі ліцензії" source="license.issuedDate" locales="ru-RU" />
                    <DateField label="Початок дії ліцензії" source="license.activeFromDate" locales="ru-RU" />
                    <DateField label="Ліцензія діє до" source="license.expiryDate" locales="ru-RU" />
                    <TextField label="Вид діяльності, що ліцензовано" source="license.whatLicensed"/>
                    <TextField label="Номер наказу" source="license.orderNo"/>
                </Tab>
            </TabbedShowLayout>
        </Show>
    );
};

export default LegalEntityShow;
